// Mantine theme configuration based on CarLeads design system
import { createTheme, MantineColorsTuple} from '@mantine/core';

// Define custom colors
const blue: MantineColorsTuple = [
  '#e3f2fd',
  '#bbdefb',
  '#90caf9',
  '#64b5f6',
  '#42a5f5',
  '#2196f3', // Primary
  '#1e88e5',
  '#1976d2', // Accent
  '#1565c0',
  '#0d47a1',
];

const orange: MantineColorsTuple = [
  '#fff3e0',
  '#ffe0b2',
  '#ffcc80',
  '#ffb74d',
  '#ffa726',
  '#ff9800', // Primary
  '#fb8c00',
  '#f57c00', // Accent
  '#ef6c00',
  '#e65100',
];

export const theme = createTheme({
  primaryColor: 'blue',
  colors: {
    blue,
    orange,
  },
  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif',
  fontFamilyMonospace: 'Monaco, Courier, monospace',
  headings: {
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif',
    fontWeight: '700',
    sizes: {
      h1: { fontSize: '32px', lineHeight: '1.3' },
      h2: { fontSize: '28px', lineHeight: '1.35' },
      h3: { fontSize: '24px', lineHeight: '1.4' },
      h4: { fontSize: '20px', lineHeight: '1.45' },
      h5: { fontSize: '18px', lineHeight: '1.5' },
      h6: { fontSize: '16px', lineHeight: '1.5' },
    },
  },
  spacing: {
    xs: '8px',
    sm: '12px',
    md: '16px',
    lg: '24px',
    xl: '32px',
  },
  radius: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px',
  },
  shadows: {
    sm: '0 1px 3px rgba(0,0,0,0.12)',
    md: '0 4px 6px rgba(0,0,0,0.1)',
    lg: '0 10px 15px rgba(0,0,0,0.1)',
    xl: '0 20px 25px rgba(0,0,0,0.1)',
  },
});
